import dummy from "../assets/images/dummy.svg";
import offsetRandom from "../assets/images/widePlank/offsetRandom.jpg";
import eightInch from "../assets/images/widePlank/8in.jpg";

export const configuratorData8 = {
  tokenUrl: 'c91ec286-fe5d-32b5-ad0a-db3a87571497',
  id: 1,
  name: 'Maine Cottage',
}

// export const REGULAR_SIZE = "Tilly"
// export const WIDE_SIZE = "Wide"

export const profileData8 = [
  {
    id: 1,
    name: "Offset Random",
    thumb: offsetRandom,
  },
];

export const layoutData8 = [
  {
    id: 1,
    name: 'Eleanor',
    thumb: eightInch,
  },
];

export const sceneData8 = [
  {
    id: 8814,
    name: "Scene",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
];

export const imageHubSpotPosition8 = {
  // 'Rug': [
  //   {
  //     style: [
  //       { top: '75%', left: '46%' },
  //     ],
  //   },
  // ],
};

export const imageData8 = [
  {
    sceneId: 45,
    labelId: 1723,
    min: 0,
    max: 1,
  },
  {
    sceneId: 423,
    labelId: 1725,
    min: 1,
    max: 2,
  },
  {
    sceneId: 424,
    labelId: 1786,
    min: 0,
    max: 1,
  },
  {
    sceneId: 755,
    labelId: 1791,
    min: 1,
    max: 2,
  },
];

export const redirectURL8 = [
  {
    url: "https://www.welspunliving.com/",
    name: "Nebula Reverie",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Celestial Cascade",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Fiona Patchwork",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Lunar Lattice",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Stardust Tapestry",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Eclipse Enigma",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Aurora Gleam",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Harlequin Reverse",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Floral Symphony",
  },
];

export const dipTrayStyle8 = [
  // {
  //   configuratorId: 2,
  //   id: 1,
  //   name: "Standard",
  //   thumb: standard,
  // },
  // {
  //   configuratorId: 2,
  //   id: 2,
  //   name: "No Drip Trays",
  //   thumb: standard,
  // },
];
